import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../_helpers/notification.service';
import { HelperService } from '../_helpers/helper.service';
import { NgModule } from '@angular/core';
import { ResetPasswordService } from './reset-password.service';
import { AppSettings } from '../_helpers/app.settings';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {

  
  password: any;
  confirmPassword: any;
  token: any = '';

  constructor(private notification: NotificationService, 
    private helper: HelperService,
    private resetPasswordService: ResetPasswordService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.fetchToken();
  }
  fetchToken() {
    this.token = this.route.snapshot?.queryParams['token'];
  }
  resetPassword() {
    let validationStatus = this.helper.isValidPassword(this.password, this.confirmPassword);
    if(validationStatus != true) {
      this.showValidationMsg(validationStatus);
      return;
    }
    let data = {
      "resetToken": this.token,
      "newPassword": btoa(this.password) 
    };

    this.resetPasswordService.updatePassword({
      data: data,
      skipToken: true,
      success: (response: any) => {
        if(response && response.message) {
          this.notification.showSuccess(response.message);
          this.router.navigate([AppSettings.LOGIN_ROUTE]);
        }
      },
      error: (error: any) => {
        this.notification.showError(error.errorMessage);
      }
    });
    
  }
  showValidationMsg(msg: any) {
    switch(msg) {
      case 'empty':
        this.notification.showError("Please enter Password.");
        break;
      case 'password':
        this.notification.showError('Both Password and Confirm Password should match.');
        break;
      case 'password_length':
        this.notification.showError('Password should contain 8-16 characters');
        break;
      case 'password_regex':
        this.notification.showError('Password must contain Alphanumeric and special characters.');
        break;
    }
  }
}
